import { TypographyProps, BoxProps } from '@mui/material';

interface GetTileThemeProps {
  today: boolean;
  isWeekendDay: boolean;
}

interface GetTileThemeResult {
  weekDayColor: TypographyProps['color'];
  dateColor: TypographyProps['color'];
  backgroundColor: BoxProps['bgcolor'];
}

export default function getTileTheme({
  today,
  isWeekendDay,
}: GetTileThemeProps): GetTileThemeResult {
  if (today) {
    return {
      backgroundColor: 'main.white',
      weekDayColor: 'text.primary',
      dateColor: 'primary.main',
    };
  }

  if (isWeekendDay) {
    return {
      backgroundColor: 'background.other',
      weekDayColor: 'text.disabled',
      dateColor: 'text.secondary',
    };
  }

  return {
    backgroundColor: 'main.white',
    weekDayColor: 'text.secondary',
    dateColor: 'text.primary',
  };
}
